import dayjs from "dayjs";

export function formatDateTimeIST(value?: Date | string | null): string {
  return value ? dayjs(value).tz("Asia/Kolkata").format("DD-MM-YYYY hh:mm A") : "-";
}


export function formatDateIST(value?: Date | string | null): string {
  return value ? dayjs(value).tz("Asia/Kolkata").format("DD-MM-YYYY") : "-";
}
